import React from 'react';
import { useSelector } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';

const ResumeAdditionalInfo = ({preview}) => {
  const pathname = window.location.pathname;
  const accompHead = useSelector(
    (store) => store.extraSecArrData.extraSecArray
  );
  const additionalData = useSelector(
    (store) => store.additionalInfoData.additionalInfo
  );

  return (
    <>
      <div className="resume-addinfo">
        {additionalData && pathname !== '/choose-template' ? (
          <>
            <h1 className={`${preview===true?'heading-resume':'resume-heading'}`}>Additional-Information</h1>
           {ReactHtmlParser(additionalData)}
          </>
        ) : !additionalData &&
          accompHead.includes('Additional-Information') &&
          pathname !== '/choose-template' ? (
          <>
            <h1 className={`${preview===true?'heading-resume':'resume-heading'}`}>Additional-Information</h1>
          </>
        ) : (
          ''
        )}
      </div>
    </>
  );
};

export default ResumeAdditionalInfo;
